import script from "./MobileReportInfoMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReportInfoMain.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=208622e9&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208622e9"]])

export default __exports__